export type TierPaletteEntry = {
  color: string;
  shadowColor: string;
};

export const TIER_COLORS: TierPaletteEntry[] = [
  { color: "#ef553d", shadowColor: "#a82d1d" },
  { color: "#e79a2f", shadowColor: "#96561b" },
  { color: "#f2bc36", shadowColor: "#a77615" },
  { color: "#bfd85d", shadowColor: "#738521" },
  { color: "#67cb84", shadowColor: "#2f7d4a" },
  { color: "#73d7c9", shadowColor: "#2b897e" },
  { color: "#6aa4d8", shadowColor: "#356691" },
  { color: "#b7bec8", shadowColor: "#717781" },
  { color: "#c6ccd5", shadowColor: "#7a8089" },
  { color: "#d3d7de", shadowColor: "#848a93" },
  { color: "#d9dde4", shadowColor: "#8b9098" },
  { color: "#e0e3e9", shadowColor: "#9298a0" },
];

export function getTierLabel(index: number): string {
  if (index === 0) return "S";
  const alphaIndex = index - 1;
  if (alphaIndex < 26) return String.fromCharCode(65 + alphaIndex);
  return `T${alphaIndex}`;
}

export function getTierPalette(index: number): TierPaletteEntry {
  return TIER_COLORS[Math.min(index, TIER_COLORS.length - 1)];
}
